module.exports = "/_next/static/images/phone-note-2-7ea95c4c2cee6d3790f3cbb4573e43c3.png.webp";